import { createContext, useContext } from "react";

import type { TabsProps } from "./Tabs.types";

export type TabsContextValue = Pick<
  TabsProps,
  "size" | "variant" | "orientation"
> & {
  flushStart: boolean;
  flushEnd: boolean;
};

export function makeTabsContext({
  size = "md",
  variant = "default",
  orientation = "horizontal",
  flushStart = false,
  flushEnd = false,
}: Partial<TabsContextValue>): Required<TabsContextValue> {
  return { size, variant, orientation, flushStart, flushEnd };
}

export const TabsContext = createContext<Required<TabsContextValue>>(
  makeTabsContext({}),
);

export function useTabsContext() {
  return useContext(TabsContext);
}
